import React from 'react'
import ComingSoon from '../../../components/ComingSoon/ComingSoon'

const Notifications = () => {
  return (
    <div>
        <ComingSoon />
    </div>
  )
}

export default Notifications